import { useEffect, useState } from 'react';

export const useUnmountAnimation = (shouldRender: boolean, animationDuration: number) => {
    const [isVisible, setIsVisible] = useState(shouldRender);
    const [isUnmounting, setIsUnmounting] = useState(false);

    useEffect(() => {
        let tiemout: string | number | NodeJS.Timeout | undefined;
        if (!shouldRender && isVisible) {
            setIsUnmounting(true);
            tiemout = setTimeout(() => setIsVisible(false), animationDuration);
        } else if (shouldRender) {
            setIsVisible(true);
            setIsUnmounting(false);
        }

        return () => {
            clearTimeout(tiemout);
        };
    }, [animationDuration, isVisible, shouldRender]);

    return {
        isUnmounting,
        isVisible
    };
};
